const MONTH_AND_DAY_STRING_WIDTH = 2

const getNumberAsPaddedString = (value: number): string =>
  String(value)
    .padStart(MONTH_AND_DAY_STRING_WIDTH, '0')
    .slice(0, MONTH_AND_DAY_STRING_WIDTH)

const getIsoDate = (date: Date): string =>
  `${date.getFullYear()}-${getNumberAsPaddedString(
    date.getMonth() + 1,
  )}-${getNumberAsPaddedString(date.getDate())}`

export const getIsoDateForTomorrow = (): string => {
  const tomorrow = new Date(Date.now())
  tomorrow.setDate(tomorrow.getDate() + 1)

  return getIsoDate(tomorrow)
}
